export const TOGGLE_MOON_ROTATION = "TOGGLE_MOON_ROTATION";
export const toggle_moon_rotation = () => ({ type: TOGGLE_MOON_ROTATION });
